<template>
  <div class="dashboard">
    <AdminNav />
    <main class="dashboard__content">
      <Aside :user="this.user" />
      <!-- <Transition name="scale" mode="out-in">
        <router-view />
      </Transition> -->
      <router-view v-slot="{ Component }">
        <Transition name="scale" mode="out-in">
          <component :is="Component" />
        </Transition>
      </router-view>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import Aside from "@/components/AdminAside.vue";
import AdminNav from "@/components/AdminNav.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "HomeView",
  data() {
    return {
      user: {},
    };
  },
  components: {
    Aside,
    AdminNav,
  },
  methods: {
    // Vuex
    ...mapActions("categoriesModule", ["fetchCategories"]),
    ...mapActions("classesModule", ["fetchClasses"]),
    ...mapActions("adminModule", ["getAdminByUid"]),
    ...mapActions("analyticsModule", ["fetchAnalytics"]),
  },
  async created() {
    // Analytics Functions
    this.fetchAnalytics();
    //-------------------------------
    this.fetchCategories();
    this.fetchClasses();
    this.getAdminByUid();
   
    if (window.innerWidth <= 991.98) {
      document.body.classList.add("aside-collapsed");
      document.getElementById("NavIcon").classList.add("d-none");
    }
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("classesModule", ["getClasses"]),
    ...mapGetters("adminModule", ["getUser"]),
  },

  mounted() {
    this.user = this.getUser;
  },
  watch: {
    getUser() {
      this.user = this.getUser;
    },
  },
};
</script>
